export interface CountryId {
  name: string;
  name_iso: string | null;
  code2_iso: string;
  code3_iso: string;
}

export interface Option {
  label: string;
  value: string | number;
}
export interface TypedOption<T> {
  label: string;
  value: T;
}

export const isOption = (opt: unknown): opt is Option => {
  return (
    typeof opt === "object" &&
    opt !== null &&
    "value" in opt &&
    "label" in opt &&
    typeof (opt as any).label === "string" &&
    (typeof (opt as any).value === "string" ||
      typeof (opt as any).value === "number")
  );
};

// This is a type guard to check whether an array contains Option types
export const isOptionArray = (arr: unknown[]): arr is Option[] => {
  return arr.length > 0 && arr.every((item) => isOption(item));
};
